import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { SelectInputProps } from './SelectInput.d'

const SelectInput2 = ({
  disabled,
  fullWidth,
  id,
  label,
  multiple,
  name,
  value,
  onChange,
  onBlur,
  defaultValue,
  options,
  required,
  padding = '',
  error,
  classes = ''
}: SelectInputProps) => {
  const [selectedOptions, setSelectedOptions] = useState([])
  const [curVal, setCurVal] = useState('')

  useEffect(() => {
    options.forEach((option: any, index: number) => {
      if (option.selected) {
        if (!multiple) {
          setSelectedOptions([option.value])
        } else {
          const newSelectedOptions = [...selectedOptions, option.value]
          setSelectedOptions([...new Set(newSelectedOptions)])
        }
      }
    })
  }, [options])

  const onChangeHandler = (e: any) => {
    onChange(e)
    setCurVal(e.target.value)
  }

  const selectStyles = classNames(classes, {
    // Base styles
    'bg-white w-full border border-gray-50 appearance-none placeholder-text-secondary placeholder-tracking-[0.2px] leading-[24px] font-normal font-sansPro rounded-[4px]':
      true,
    'text-default': value,
    'text-secondary': value !== '',
    '!text-gray-100': curVal === '',
    '!text-black': curVal !== '',
    // Transitions
    'transition-colors transition-shadow duration-300': true,
    // Dropdown arrow, only on single select (not multiple)
    'bg-arrow-drop-down-dark bg-no-repeat bg-[center_right_1rem]': !multiple,
    'relative [@media(min-width:576px)]:top-[-7px]': !fullWidth,
    // Arrow down
    // 'bg-arrow-drop-down-dark  ': true,
    // Error
    'border !border-error text-error': error,

    // Padding
    'py-3 px-[10px] h-[50px]': padding === 'large',
    'px-4 py-3 h-[48px]': padding === 'medium',
    'px-3 py-2': padding === ''
  })

  const errorClassNames = classNames(
    'flex flex-row font-sansPro items-center absolute bottom-[-16px] !text-[12px] text-error text-sm left-0 leading-4 mt-2 xl:mb-[-1px] pl-[2px] text-[#f98699]'
  )

  return (
    <>
      <select
        className={selectStyles}
        defaultValue={defaultValue ?? options[0].value}
        disabled={disabled}
        id={id}
        multiple={multiple}
        name={name}
        onBlur={onBlur}
        onChange={onChangeHandler}
        required={required}
      >
        {options.map(
          ({ disabled: optionDisabled, value, label: optionLabel }) => {
            const optionStyles = classNames({
              'text-secondary': optionDisabled
            })
            return (
              <option
                className={optionStyles}
                disabled={optionDisabled}
                key={value}
                value={value}
              >
                {optionLabel}
              </option>
            )
          }
        )}
      </select>
      <label className='sr-only' htmlFor={id}>
        {label}
      </label>
      {error ? (
        <div className={errorClassNames} role='alert'>
          {error}
        </div>
      ) : null}
    </>
  )
}

export default SelectInput2
